// Admin routes for P7b-basic (slot `marketing`: REVIEW-02 moderation). The router mounts whatever
// this returns under the app shell (before the store-area placeholder), so modules never edit
// router.tsx. Paths follow IA §2.1. The blog (CONTENT-02) is API-only in this basic cut.
// Owner, 2026-10-22: the Marketing tabs that were previews are built (newsletter subscribers, flash
// deals, offer pop-up, checkout links, affiliates).
import {
  createRoute,
  type AnyRoute,
  type RouteComponent,
  lazyRouteComponent,
} from "@tanstack/react-router";

// Pages are code-split: each loads when its route opens, not with the shell.
const load1 = () => import("../marketing/AffiliatesPage");
const AffiliatesPage = lazyRouteComponent(load1, "AffiliatesPage");
const load2 = () => import("../marketing/CheckoutLinksPage");
const CheckoutLinksPage = lazyRouteComponent(load2, "CheckoutLinksPage");
const load3 = () => import("../marketing/FlashDealsPage");
const FlashDealsPage = lazyRouteComponent(load3, "FlashDealsPage");
const load4 = () => import("../marketing/NewsletterPage");
const NewsletterPage = lazyRouteComponent(load4, "NewsletterPage");
const load5 = () => import("../marketing/OfferPopupPage");
const OfferPopupPage = lazyRouteComponent(load5, "OfferPopupPage");
const load6 = () => import("../marketing/ReviewsPage");
const ReviewsPage = lazyRouteComponent(load6, "ReviewsPage");

export function marketingRoutes(appRoute: AnyRoute): AnyRoute[] {
  const at = (path: string, component: RouteComponent) =>
    createRoute({ getParentRoute: () => appRoute, path, component }) as unknown as AnyRoute;
  return [
    at("/$org/$store/customers/reviews", ReviewsPage),
    at("/$org/$store/marketing/newsletter", NewsletterPage),
    at("/$org/$store/marketing/flash-deals", FlashDealsPage),
    at("/$org/$store/marketing/offer-popup", OfferPopupPage),
    at("/$org/$store/marketing/links", CheckoutLinksPage),
    at("/$org/$store/marketing/affiliates", AffiliatesPage),
  ];
}
